(function() {

  var formParent = document.querySelector('[data-form="login"]');

  var handleFormSwitchClick = function() {
    var formValue = this.getAttribute('data-account-form-change');

    if (!formValue) { return; }


    formParent.setAttribute('data-form', formValue);
  }

  var formSwitcherList = document.querySelectorAll('[data-account-form-change]');

  formSwitcherList.forEach(function(elem) {
    elem.addEventListener('click', handleFormSwitchClick);
  });

})();